import { Component, OnInit } from '@angular/core';
import { UserService } from '../../shared/user.service';
import { ErrorHandler } from '../../shared/ErrorHandler';

@Component({
  selector: 'app-overdue-reports',
  templateUrl: './overdue-reports.component.html',
  styleUrls: ['./overdue-reports.component.css']
})
export class OverdueReportsComponent implements OnInit {

  constructor(private userService: UserService,private errorHandler: ErrorHandler) { }

  ngOnInit() {
    this.OverdueReport();
  }

  OverdueReport = function(){
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.overdueReport()
    .subscribe((data:any)=>{
      this.TicketsList = data;
      document.getElementById('loader-spinner').style.display = "none";
    },(error)=>{
      document.getElementById('loader-spinner').style.display = "none";
      this.errorHandler.HandlerError(error);
    });

}

}



// WEBPACK FOOTER //
// ./src/app/reports/overdue-reports/overdue-reports.component.ts